import * as React from "react"

import Details from "Catalog/Edit/shared/components/Details"
import useCatalogNavigation from "Catalog/shared/hooks/useCatalogNavigation"
import useNavigateNoUpdate from "shared/hooks/useNavigateNoUpdate"
import { IDeal } from "shared/hubrise/models"

const Preview = ({ deal }: { deal: IDeal }): JSX.Element => {
  const navigate = useNavigateNoUpdate()
  const { catalogNavigation } = useCatalogNavigation()

  return (
    <Details.TopbarButton onClick={() => navigate(catalogNavigation.previewPath("deal", deal.id))} code="visibility" />
  )
}

export default Preview
